import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';

/**
 * Implementación de MatPaginatorIntl que usa ngx-translate
 * para mostrar los textos del paginador en el idioma activo.
 */
@Injectable()
export class I18nMatPaginatorIntl extends MatPaginatorIntl {

  constructor(private readonly translate: TranslateService) {
    super();
    this.initLabels();

    // Cuando cambie el idioma, actualizamos las etiquetas
    this.translate.onLangChange.subscribe(() => {
      this.initLabels();
      this.changes.next();
    });
  }

  /**
   * Carga los textos desde los ficheros de traducciones
   * y asigna la función getRangeLabel como propiedad.
   */
  private initLabels(): void {
    this.itemsPerPageLabel  = this.translate.instant('paginator.itemsPerPageLabel');
    this.nextPageLabel      = this.translate.instant('paginator.nextPageLabel');
    this.previousPageLabel  = this.translate.instant('paginator.previousPageLabel');
    this.firstPageLabel     = this.translate.instant('paginator.firstPageLabel');
    this.lastPageLabel      = this.translate.instant('paginator.lastPageLabel');

    this.getRangeLabel = (page: number, pageSize: number, length: number): string => {
      if (length === 0 || pageSize === 0) {
        return this.translate.instant('paginator.rangeLabelZero', { length });
      }

      const startIndex = page * pageSize;
      const endIndex =
        startIndex < length
          ? Math.min(startIndex + pageSize, length)
          : startIndex + pageSize;

      return this.translate.instant('paginator.rangeLabel', {
        startIndex: startIndex + 1,
        endIndex,
        length
      });
    };
  }
}
